<script setup>
import moment from "moment/moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          Master Data Kontrak
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>
        <div v-if="userData.kontraktorID != null" @click="tambahKontrak()"
          class="flex mt-5 gap-2 items-center cursor-pointer">
          <font-awesome-icon icon="fa-solid fa-square-plus" class="text-red-600" />
          <h6 class="text-red-600 text-sm font-inter font-bold">
            Tambah Kontrak
          </h6>
        </div>
        <v-row class="bg-white rounded-lg p-3 shadow-md mt-5">
          <v-col cols="4">
            <v-text-field variant="outlined" density="compact" color="red" hide-details clearable
              v-model="formValues.keyword" v-on:keyup.enter="cariKontrak" prepend-inner-icon="mdi-magnify"
              placeholder="Masukkan Nama Kontraktor"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn data-bs-toggle="modal" data-bs-target="#exampleModal" prepend-icon="mdi-filter"
              class="w-full bg-slate-50 text-slate-600 capitalize">
              Cari Berdasarkan
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn class="bg-red-600 w-full text-white capitalize" @click="cariKontrak()">
              Cari Kontrak
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <div class="mt-8 rounded-lg shadow-md overflow-x-auto w-full">
        <v-data-table-server v-model:page="dataTable.pagination.page"
          v-model:items-per-page="dataTable.pagination.itemsPerPage" :items-per-page-options="[5, 10, 25, 50, 100]"
          :headers="filteredHeaders" :items="dataTable.items" :items-length="dataTable.pagination.totalItems"
          @update:options="fetchData">
          <template v-slot:item="{ item, index }">
            <tr class="border-b border-gray-950 h-16" :class="{ 'bg-gray-50': index % 2 !== 0 }">
              <td>
                <div class="flex gap-2 items-center">
                  <img src="../../assets/images/search.png" @click="redirectToLink('/kontrak/detail/', item.id)"
                    class="mix-blend-multiply min-w-5 w-5 h-auto cursor-pointer" alt="" />
                  <i v-if="item.server === 'cms'" class="mdi mdi-delete text-red-600 text-2xl cursor-pointer"
                    @click="hapusKontrak(item.id)"></i>
                </div>
              </td>
              <td class="text-nowrap">{{ item.oaNumber }}</td>
              <td class="text-wrap">{{ item.poNumber }}</td>
              <td class="text-nowrap">{{ item.title }}</td>
              <td class="text-wrap">
                <div v-if="
                  item.validityEnd >= moment(dateNow).format('YYYY-MM-DD')
                ">
                  <span class="text-green-600 font-medium"> Aktif </span>
                </div>
                <div v-else>
                  <span class="text-gray-600 font-medium"> Non Aktif</span>
                </div>
              </td>
              <td class="text-nowrap" v-if="userData?.kontraktorID == null">
                {{ item.namaKontraktor }}
              </td>
              <td class="text-nowrap">
                <div class="flex flex-col gap-2">
                  <div class="flex text-nowrap">
                    <span>NIB: {{ item.noNib == null ? "-" : item.noNib }}</span>
                  </div>
                  <div class="flex text-nowrap">
                    <span>IUJP: {{ item.noIujp == null ? "-" : item.noIujp }}</span>
                  </div>
                </div>
              </td>
              <td class="text-nowrap">{{ item.namaPjo }}</td>
              <td class="text-center text-capitalized text-nowrap">
                <div class="px-1 rounded-md flex items-center gap-2 w-fit" :class="{
                  'bg-[#ffe5e5] text-[#dd3737]': item.tingkatResiko == '4',
                  'bg-[#f4eadb] text-[#ff8800]': item.tingkatResiko == '3',
                  'bg-[#ddfbec] text-[#0c8953]': item.tingkatResiko == '2',
                  'bg-[#c8bde0] text-[#720c89]': item.tingkatResiko == '1',
                }">
                  <i class="mdi mdi-circle text-[8px]" v-if="[1, 2, 3, 4].includes(item.tingkatResiko)"></i>
                  <span class="font-semibold text-xs">
                    {{
                      item.tingkatResiko == 4
                        ? "Tinggi"
                        : item.tingkatResiko == 3
                          ? "Tinggi Menengah"
                          : item.tingkatResiko == 2
                            ? "Rendah Menengah"
                            : item.tingkatResiko == 1
                              ? "Rendah"
                              : ""
                    }}
                  </span>
                </div>
              </td>
              <td class="text-nowrap">
                {{
                  item.validityStart == null
                    ? "-"
                    : moment(item.validityStart).format("DD/MMM/YYYY")
                }}
              </td>
              <td class="text-nowrap">
                {{
                  item.validityEnd == null
                    ? "-"
                    : moment(item.validityEnd).format("DD/MMM/YYYY")
                }}
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </div>
    </v-row>
  </DefaultLayout>

  <!-- modal filter -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- <div class="modal-header">
                    <h5 class="modal-title">Modal title</h5>
                    
                </div> -->
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <div class="d-flex justify-content-end w-100">
            <button type="button" id="btnClose" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="mb-1">
                <label for="urutan" class="form-label fs-8 fw-bold">Urutan</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="radio" value="terbaru" id="urutan_terbaru"
                    v-model="formValues.urutan" />
                  <label class="form-check-label fs-9" for="urutan_terbaru">
                    Terbaru
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="terlama" id="urutan_terlama"
                    v-model="formValues.urutan" />
                  <label class="form-check-label fs-9" for="urutan_terlama">
                    Terlama
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold">Status</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="aktif" id="status_aktif"
                    v-model="formValues.status_kontrak" />
                  <label class="form-check-label fs-9" for="status_aktif">
                    Aktif
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="non_aktif" id="status_non_aktif"
                    v-model="formValues.status_kontrak" />
                  <label class="form-check-label fs-9" for="status_non_aktif">
                    Non Aktif
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold">Tingkat Resiko</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="1" id="tr_1"
                    v-model="formValues.tingkatResiko" />
                  <label class="form-check-label fs-9" for="tr_1">
                    Rendah
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="2" id="tr_2"
                    v-model="formValues.tingkatResiko" />
                  <label class="form-check-label fs-9" for="tr_2">
                    Rendah Menengah
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="3" id="tr_3"
                    v-model="formValues.tingkatResiko" />
                  <label class="form-check-label fs-9" for="tr_3">
                    Tinggi Menengah
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="4" id="tr_4"
                    v-model="formValues.tingkatResiko" />
                  <label class="form-check-label fs-9" for="tr_4">
                    Tinggi
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button> -->
          <button class="btn btn_cari w-100 fs-8 fw-bold" @click="terapkan">
            Terapkan
          </button>
          <button class="btn btn_refresh w-100 fs-8 fw-bold" @click="refresh">
            Refresh Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GlobalDataMixin from "@/GlobalDataMixin";
//import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
// import SidebarComponent from "@/components/SideBar.vue";
import { API_BASE_URL, CMS_DELETE_KONTRAK, CMS_KONTRAK } from "@/constants";
import axios from "axios";
import router from "@/router";
import Swal from "sweetalert2";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

const url_data_kontrak = API_BASE_URL + CMS_KONTRAK;
const url_delete_kontrak = API_BASE_URL + CMS_DELETE_KONTRAK;

export default {
  mixins: [GlobalDataMixin],
  name: "KontrakPage",
  components: {
    //FontAwesomeIcon,
    // SidebarComponent,
    DefaultLayout,
  },
  computed: {
    filteredHeaders() {
      return this.userData.kontraktorID
        ? this.dataTable.headers.filter(
          (header) => header.title !== "Kontraktor"
        )
        : this.dataTable.headers;
    },
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "", align: "start", sortable: false, width: "3%" },
        { title: "NOA", align: "start", sortable: false, width: "10%" },
        { title: "No. PO", align: "start", sortable: false, width: "10%" },
        {
          title: "Nama Kontrak",
          align: "start",
          sortable: false,
          width: "15%",
        },
        { title: "Status", align: "start", sortable: false, width: "10%" },
        { title: "Kontraktor", align: "start", sortable: false, width: "15%" },
        { title: "Izin Kerja", align: "start", sortable: false, width: "12%" },
        { title: "PJO", align: "start", sortable: false, width: "5%" },
        {
          title: "Tingkat Resiko",
          align: "start",
          sortable: false,
          width: "5%",
        },
        {
          title: "Tanggal Mulai",
          align: "start",
          sortable: false,
          width: "7.5%",
        },
        {
          title: "Tanggal Selesai",
          align: "start",
          sortable: false,
          width: "7.5%",
        },
      ]),
      kontrak: [],
      currentPage: 1,
      totalData: 0,
      formValues: {
        keyword: null,
        perPage: 5,
        status_kontrak: [],
        urutan: null,
        tingkatResiko: [],
      },
      role: "",
      dateNow: new Date(),
      filtersInitialized: false,
    };
  },
  created() {
    this.initFiltersFromQuery();
  },
  mounted() {
    this.role = this.userData.role;
    this.initFiltersFromQuery();
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.formValues.keyword = q.keyword ?? null;
      if (q.urutan !== undefined) this.formValues.urutan = q.urutan;
      if (q.status_kontrak) {
        this.formValues.status_kontrak = Array.isArray(q.status_kontrak)
          ? q.status_kontrak
          : [q.status_kontrak];
      }
      if (q.tingkatResiko) {
        this.formValues.tingkatResiko = Array.isArray(q.tingkatResiko)
          ? q.tingkatResiko
          : [q.tingkatResiko];
      }
      if (q.page !== undefined && q.page !== "") {
        this.currentPage = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.formValues.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        keyword: this.formValues.keyword || undefined,
        urutan: this.formValues.urutan || undefined,
        status_kontrak:
          this.formValues.status_kontrak.length > 0
            ? this.formValues.status_kontrak
            : undefined,
        tingkatResiko:
          this.formValues.tingkatResiko.length > 0
            ? this.formValues.tingkatResiko
            : undefined,
        page:
          this.dataTable.pagination.page > 1
            ? this.dataTable.pagination.page
            : undefined,
        perPage:
          this.dataTable.pagination.itemsPerPage !== 5
            ? this.dataTable.pagination.itemsPerPage
            : undefined,
      };
      this.$router.replace({ query }).catch(() => { });
    },
    buildKontrakQuery() {
      const q = {};
      if (this.formValues.keyword) q.keyword = this.formValues.keyword;
      if (this.formValues.urutan) q.urutan = this.formValues.urutan;
      if (this.formValues.status_kontrak.length > 0)
        q.status_kontrak = this.formValues.status_kontrak;
      if (this.formValues.tingkatResiko.length > 0)
        q.tingkatResiko = this.formValues.tingkatResiko;
      if (this.dataTable.pagination.page > 1)
        q.page = this.dataTable.pagination.page;
      if (this.dataTable.pagination.itemsPerPage !== 5)
        q.perPage = this.dataTable.pagination.itemsPerPage;
      return q;
    },
    closeModal() {
      document.getElementById("btnClose").click();
    },
    terapkan() {
      this.closeModal();
      this.cariKontrak();
    },
    refresh() {
      this.formValues.keyword = null;
      this.formValues.status_kontrak = [];
      this.formValues.urutan = null;
      this.formValues.tingkatResiko = [];
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.closeModal();
      this.fetchData();
    },
    redirectToLink(link, id) {
      router.push({
        path: link + id,
        query: this.buildKontrakQuery(),
      });
    },
    preventSubmit() {
      console.log("prevent submit");
    },
    resetPaginasi() {
      this.kontrak = [];
      this.formValues.perPage = 5;
      this.currentPage = 1;
      this.totalData = 0;
    },
    cariKontrak() {
      this.resetPaginasi();
      this.syncFiltersToUrl();
      this.fetchData();
    },
    tambahKontrak() {
      this.$router.push({
        path: "/addkontrak",
        query: this.buildKontrakQuery(),
      });
    },
    fetchData({ page, itemsPerPage } = {}) {
      let stat = null;
      let sort = null;

      if (page) {
        this.currentPage = page;
        this.dataTable.pagination.page = page;
      }
      if (itemsPerPage) {
        this.formValues.perPage = itemsPerPage;
        this.dataTable.pagination.itemsPerPage = itemsPerPage;
      }
      this.syncFiltersToUrl();

      if (this.formValues.status_kontrak.length == 1) {
        if (this.formValues.status_kontrak[0] == "aktif") {
          stat = true;
        } else {
          stat = false;
        }
      }

      if (this.formValues.urutan == "terbaru") {
        sort = true;
      } else if (this.formValues.urutan == "terlama") {
        sort = false;
      }

      let bodyJson = {
        header: {
          page: this.currentPage,
          perPage: this.formValues.perPage,
          usecase: this.userData.kontraktorID != null ? "kontraktor" : "isafe",
        },
        kontraktorID:
          this.userData.kontraktorID != null
            ? this.userData.kontraktorID
            : null,
        namaKontraktor:
          this.formValues.keyword == "" ? null : this.formValues.keyword,
        status: stat,
        tingkatResiko:
          this.formValues.tingkatResiko.length == 0
            ? null
            : this.formValues.tingkatResiko,
        orderBy: {
          createdTimeNew: sort,
        },
      };
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe";
      let config = {
        headers: {
          role: role,
          Authorization: `Bearer ${tokens.token}`,
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
        },
      };
      axios
        .post(url_data_kontrak, bodyJson, config)
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.totalData;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.kontrak = response.data.data;
          this.totalData = response.data.totalData;
          console.log(this.kontrak);
        })
        .catch((error) => {
          if (error.responsestatus != 400) {
            alert("Error Fetch Data List Kontrak : " + error.message);
            console.error("Error fetching data:", error);
          } else {
            this.kontrak = [];
            this.totalData = 0;
          }
        });
    },
    changePage(num) {
      let cp = this.currentPage + num;
      if (
        !(num == -1 && this.currentPage == 1) &&
        cp * this.formValues.perPage <=
        this.totalData + (this.formValues.perPage - 1)
      ) {
        this.currentPage = this.currentPage + num;
        this.fetchData();
      }
    },
    hapusKontrak(id) {
      console.log(id);

      Swal.fire({
        title: "Hapus Kontrak",
        text: "Apakah anda yakin akan menghapus data kontrak ini ?",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteKontrack(id);
        }
      });
    },
    deleteKontrack(id) {
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe";
      axios
        .get(url_delete_kontrak, {
          params: {
            id: id,
          },
          headers: {
            role: role,
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then(() => {
          Swal.fire({
            title: "Hapus Kontrak",
            text: "Data Kontrak telah dihapus !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          console.log(error);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan (" + error.response.data.message + ")",
          });
        });
    },
  },
};
</script>
<style scoped>
:deep(table) {
  table-layout: auto !important;
  width: max-content !important;
  min-width: 100%;
}

:deep(thead) {
  background-color: #fecaca;
}
</style>
